import jump from '../../vendor/jump';

function init() {
  const jumpers = document.querySelectorAll('[data-jump]');

  if (!jumpers) {
    return;
  }

  Array.from(jumpers).forEach((jumper) => {
    jumper.addEventListener('click', (e) => {
      e.preventDefault();
      jump(jumper.getAttribute('href'), {
        duration: 500
      });
    });
  });
}

export default init;
